import useRequest from "./request";

//
export async function liveShareDetail(data: any) {
  let { response, request } = useRequest<any>(
    "/live/share/detail",
    {
      method: "post",
      data
    }
  );
  await request();
  return response;
}

// 获取city
export async function getCityDetail(data: any) {
  let { response, request } = useRequest<any>(
    "/city/home/web/info",
    {
      method: "post",
      data
    }
  );
  await request();
  return response;
}